import React from "react";
import { Typography, Paper, Box, Link } from "@mui/material";

function Terms() {
  return (
    <Box
      sx={{
        backgroundColor: "#f4f9ff",
        minHeight: "100vh",
        p: 2,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      {/* Header */}
      <div className="header">
        <img src="/logo.png" alt="Smart Parking Logo" className="logo" />
        <div className="heading-text">
          <br />
          <Typography variant="h4" className="title">
            Smart Parking App
          </Typography>
          <Typography variant="body2" className="caption">
            "Empowering Digital India .."
          </Typography>
        </div>
      </div>



      {/* Main Content */}
      <Paper
        elevation={3}
        sx={{
          p: 3,
          borderRadius: 4,
          backgroundColor: "#ffffff",
          maxWidth: 380,
          width: "87%",
          mx: "auto",
        }}
      >
        <Typography
          variant="h5"
          sx={{ mb: 2, fontWeight: "medium", color: "#1565c0" }}
        >
          Terms of Use
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Welcome to the Smart Parking App. By using our services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          1. Data Collection
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We collect only the minimum information necessary to provide our parking services. This includes:
          <ul>
            <li>Your vehicle number, to identify your vehicle for parking purposes.</li>
            <li>Basic information required for payment processing, such as name and contact details, as mandated by our payment provider, Razorpay.</li>
          </ul>
          We do not collect or store any additional personal data.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          2. Payment Processing
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          Payments for parking services are processed securely through Razorpay, a third-party payment gateway. We do not store any payment method details, such as credit card numbers, bank account information, or other sensitive financial data. All payment transactions are handled directly by Razorpay in accordance with their terms and privacy policies.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          3. Use of Services
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          You agree to use the Smart Parking App solely for lawful purposes related to parking within the Kalimpong Municipality area. You are responsible for providing accurate vehicle and payment information to ensure smooth service delivery.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          4. Limitation of Liability
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          The Smart Parking App is provided on an "as-is" basis. We are not liable for any damages or losses arising from the use of our services, including issues related to payment processing or parking availability, to the extent permitted by law.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          5. Changes to Terms
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          We reserve the right to update or modify these terms and conditions at any time. Any changes will be posted on this page, and continued use of the app constitutes acceptance of the updated terms.
        </Typography>

        <Typography variant="h6" sx={{ mt: 3, mb: 1, color: "#1565c0" }}>
          6. Contact Us
        </Typography>
        <Typography variant="body1" sx={{ mb: 2, color: "#424242" }}>
          For any questions or concerns regarding these terms, please contact us at:
          <br />
          Email: <Link href="mailto:parkingsupport@apptech.co.in" sx={{ color: "#1565c0" }}>parkingsupport@apptech.co.in</Link>
          <br />
          Phone: <Link href="tel:+917001841402" sx={{ color: "#1565c0" }}>+91 7001841402</Link>
        </Typography>
      </Paper>
    </Box>
  );
}

export default Terms;